import { render, staticRenderFns } from "./AlertePrix.vue?vue&type=template&id=5b68aaa9&scoped=true"
import script from "./AlertePrix.vue?vue&type=script&lang=js"
export * from "./AlertePrix.vue?vue&type=script&lang=js"
import style0 from "./AlertePrix.vue?vue&type=style&index=0&id=5b68aaa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68aaa9",
  null
  
)

export default component.exports